import PropTypes from "prop-types";
import React from "react";
import { StaticQuery, graphql } from "gatsby";

import AllBlogPosts from "./AllBlogPosts";

const query = graphql`
  query {
    ...allPublishedBlogPosts
  }
`;

const AllBlogPostsContainer = ({ currentPost }) => {
  return (
    <StaticQuery
      query={query}
      render={data => <AllBlogPosts {...data} currentPost={currentPost} />}
    />
  );
};

AllBlogPostsContainer.propTypes = {
  currentPost: PropTypes.shape({
    title: PropTypes.string,
    slug: PropTypes.string
  }).isRequired
};

export default AllBlogPostsContainer;
